export default {
  mounted() {
    let { displayPageName } = this.$options
    if (!displayPageName) { return }
    displayPageName = typeof displayPageName === 'function'
      ? displayPageName.call(this) : displayPageName
    this.$store.dispatch('displayPageName/setPageName', {
      pageName: displayPageName
    })
  }
}
